import React, { Component, useState } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { Query } from '@apollo/client/react/components';
import { GET_CATEGORIES } from '../../graphql/queries';

// Get current date formatted as "DayName, Month Day"
const getCurrentDate = () => {
    const date = new Date();
    const options = { weekday: 'long', month: 'long', day: 'numeric' };
    return date.toLocaleDateString('en-US', options);
};

const Navbar = () => {
    const [searchQuery, setSearchQuery] = useState('');
    const history = useHistory();
    const publicUrl = process.env.PUBLIC_URL + '/';

    const handleSearchSubmit = (e) => {
        e.preventDefault();
        if (searchQuery.trim()) {
            history.push(`/search?q=${encodeURIComponent(searchQuery.trim())}`);
            setSearchQuery('');
        }
    };

    return (
           <div className="navbar-area">
			  {/* topbar end*/}
			  <div className="topbar-area">
			    <div className="container">
			      <div className="row justify-content-center">
			        <div className="col-lg-6 col-md-7 align-self-center">
			          <div className="topbar-menu text-md-left text-center">
			            {/* <ul className="align-self-center">
			              <li><Link to="/author">Author</Link></li>
			              <li><Link to="/cat-page">Tech News</Link></li>
			              <li><Link to="/cat-fashion">Fashion</Link></li>
			              <li><Link to="/cat-life-style">Life Style</Link></li>
			            </ul> */
			            // <Link className="main-logo" to="/"><img src={publicUrl+"assets/img/logo.png"} alt="img" /></Link>
						<h2 className="text-3xl font-bold text-white"> <Link to="/">SenioFM</Link></h2>
						}
			          </div>
			        </div>
			        <div className="col-lg-6 col-md-5 mt-2 mt-md-0 text-md-right text-center">
			          <div className="topbar-social">
			            <div className="topbar-date d-none d-lg-inline-block"><i className="fa fa-calendar" /> {getCurrentDate()}</div>
			            <ul className="social-area social-area-2">
			              <li><a className="facebook-icon" href="https://www.facebook.com/solverwp/"><i className="fa fa-facebook" /></a></li>
			              <li><a className="twitter-icon" href="https://www.twitter.com/solverwp/"><i className="fa fa-twitter" /></a></li>
			              <li><a className="youtube-icon" href="https://www.youtube.com/solverwp/"><i className="fa fa-youtube-play" /></a></li>
			              <li><a className="instagram-icon" href="https://www.instagram.com/solverwp/"><i className="fa fa-instagram" /></a></li>
			              <li><a className="google-icon" href="https://www.google.com/solverwp/"><i className="fa fa-google-plus" /></a></li>
			            </ul>
			          </div>
			        </div>
			      </div>
			    </div>
			  </div>
			  {/* topbar end*/}
			  {/* adbar end*/}
			  {/* <div className="adbar-area bg-black d-none d-lg-block">
			    <div className="container">
			      <div className="row">
			        <div className="col-xl-6 col-lg-5 align-self-center">
			          <div className="logo text-md-left text-center">
			            <Link className="main-logo" to="/"><img src={publicUrl+"assets/img/logo.png"} alt="img" /></Link>
			          </div>
			        </div>
			        <div className="col-xl-6 col-lg-7 text-md-right text-center">
			          <a href="#" className="adbar-right">
			            <img src={publicUrl+"assets/img/add/1.png"} alt="img" />
			          </a>
			        </div>
			      </div>
			    </div>
			  </div> */}
			  {/* adbar end*/}
			  {/* navbar start */}
			  <nav className="navbar navbar-expand-lg">
			    <div className="container nav-container">
			      <div className="responsive-mobile-menu">
			        <div className="logo d-lg-none d-block">
			          <Link className="main-logo" to="/"><img src={publicUrl+"assets/img/logo.png"} alt="img" /></Link>
			        </div>
			        <button className="menu toggle-btn d-block d-lg-none" data-target="#nextpage_main_menu" aria-expanded="false" aria-label="Toggle navigation">
			          <span className="icon-left" />
			          <span className="icon-right" />
			        </button>
			      </div>
			      <div className="nav-right-part nav-right-part-mobile">
			        <a className="search header-search" href="#"><i className="fa fa-search" /></a>
			      </div>
			      <div className="collapse navbar-collapse" id="nextpage_main_menu">
			        <ul className="navbar-nav menu-open">
			          <li>
			            <Link to="/">Home</Link>
			          </li>
			          <Query query={GET_CATEGORIES}>
			            {({ loading, error, data }) => {
			              if (loading) return null;
			              if (error) return null;

			              // Get top 5 categories
			              const categories = data?.categories?.nodes?.slice(0, 5) || [];

			              return categories.map((category) => (
			                <li key={category.id}>
			                  <Link to={`/category/${category.slug}`}>{category.name}</Link>
			                </li>
			              ));
			            }}
			          </Query>
			        </ul>
			      </div>
			      <div className="nav-right-part nav-right-part-desktop">
			        <form onSubmit={handleSearchSubmit} className="menu-search-inner">
			          <input
			            type="text"
			            placeholder="Search For"
			            value={searchQuery}
			            onChange={(e) => setSearchQuery(e.target.value)}
			          />
			          <button type="submit" className="submit-btn"><i className="fa fa-search" /></button>
			        </form>
			      </div>
			    </div>
			  </nav>
			</div>
    );
};

export default Navbar